import React, { FC } from 'react';
import { RocheUIStagingHero, RocheUIHeroVariant, RocheUIImageRatio } from '@repo/roche-ui';
import { BlokToComponentProps } from '../../helpers/blok-to-component/types';
import { SlottedImageDataType } from '../../helpers/slotted-to-image/types';
import { getImageOrVideo } from '../../helpers/slotted-to-image';

type RocheStagingHeroProps = BlokToComponentProps<{
  slotted_image: SlottedImageDataType[];
  variant?: RocheUIHeroVariant;
  headline?: string;
  content?: string;
  slot?: string;
}>;

export const RocheStagingHero: FC<RocheStagingHeroProps> = ({ blok, slot }) => {
  const isVariantB = blok.variant === RocheUIHeroVariant.VARIANT_B;

  return (
    <RocheUIStagingHero
      slot={slot}
      variant={blok.variant as RocheUIHeroVariant}
      headline={blok.headline}
      content={blok.content}
      Image={isVariantB && getImageOrVideo(blok.slotted_image, RocheUIImageRatio.WIDE)}
    />
  );
};
